export const MetricsSkeleton: React.FC = () => (
  <div className="sc-metrics" data-testid="contractors-metrics-skeleton">
    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="sc-metric-card sc-metric-card--skeleton">
        <div className="sc-metric-card__info">
          <div className="sc-skeleton sc-skeleton--label" />
          <div className="sc-skeleton sc-skeleton--value" />
          <div className="sc-skeleton sc-skeleton--change" />
        </div>
        <div className="sc-skeleton sc-skeleton--sparkline" />
      </div>
    ))}
  </div>
);
